module.exports = __webpack_public_path__ + "static/media/9DESA5.64e52d88.jpg";